import React from 'react';
import {findDOMNode} from 'react-dom';

export type HoverComponentProps = {
    disableMouseEnterListeners      : boolean
}

type State = {
    isMouseEntered      : boolean
}


// DEPRECATED - nedavno sdelal ego TSX... nadeus' bugs ne budet no kto ego znaet... zrya trogal
export default class HoverComponent extends React.Component<HoverComponentProps, State> {

    // static propTypes = {
    //     disableMouseEnterListeners: PropTypes.bool,
    // };

    static defaultProps = {
        disableMouseEnterListeners: false
    };

    public componentEl          : any // component


    constructor(props:HoverComponentProps) {
        super(props);

        this.state = _.assign(this.state, {
            isMouseEntered: false
        });

        this._bind('onMouseEnter', 'onMouseLeave');
    }

    componentDidMount() {
        this.componentEl = findDOMNode(this)

        if (this.props.disableMouseEnterListeners || !this.componentEl) return
        this.componentEl.addEventListener("mouseenter", this.onMouseEnter)
        this.componentEl.addEventListener("mouseleave", this.onMouseLeave)
    }

    componentWillUnmount() {
        if (this.componentEl) {
            if (!this.props.disableMouseEnterListeners) {
                this.componentEl.removeEventListener("mouseenter", this.onMouseEnter)
                this.componentEl.removeEventListener("mouseleave", this.onMouseLeave)
            }

            this.componentEl = null
        }
    }

    getComponentNode = () => {
        return this.componentEl;
    }

    onMouseEnter(e:React.SyntheticEvent, callback:callback) {
        this.setState({
            isMouseEntered: true
        }, ()=>{if(callback) callback(e)})
    }

    onMouseLeave(e:React.SyntheticEvent, callback:callback) {
        this.setState({
            isMouseEntered: false
        }, ()=>{if(callback) callback(e)})
    }


    // From Base components
    // yes we need them

    _bind(...methods:any) {
        methods.forEach((method:any)=>{
            try {
                // @ts-ignore
                this[method] = this[method].bind(this);
            } catch(err) {
                console.error("BaseComponent","_bind error:", method, err);
            }
        });
    }

    addClass(className:string, ref:any) {
        const node = ref ? findDOMNode(ref) : this.componentEl
        if (node) { // @ts-ignore
            node.classList.add(className);
        }
    }

    removeClass(className:string, ref:any) {
        const node = ref ? findDOMNode(ref) : this.componentEl
        if (node) { // @ts-ignore
            node.classList.remove(className)
        }
    }

    toggleClass(className:string, value:boolean, ref:any) {
        value ? this.addClass(className, ref) : this.removeClass(className, ref)
    }



}